import cx from 'classnames';
import omit from 'lodash/omit';
import PropTypes from 'prop-types';
import React from 'react';

import './course-journal__table-cell.scss';

const CourseJournalCell = (props) => (
    <div {...omit(props, 'mix')} className={cx('course-journal__table-cell', props.mix)}>
        {props.children}
    </div>
);

CourseJournalCell.propTypes = {
    children: PropTypes.node,
    mix: PropTypes.string,
};

export default CourseJournalCell;
